import { CompanyTrialList } from "@/features/company/pages/CompanyTrialList";
import { FC } from "react";

const TrialCompanyListPage: FC = () => {
  return <CompanyTrialList />;
};

export default TrialCompanyListPage;
